import NewPasswordView from '../components/NewPasswordView';
import connectForm from 'utils/connectForm';
import validate from '../validate';
import { resetPassword } from '../../../modules/auth';
import { actions as notificationActions } from '../../../components/Notifs';

export default connectForm(NewPasswordView, {
  form: 'resetPwdForm',
  validate,
  mapStateToProps: state => ({}),
  mapActionCreators: {
    resetPassword,
    notifSend: notificationActions.notifSend
  }
});
